module.exports = __webpack_public_path__ + "pc-top-assets/img/info-price.bff78675.jpg";